import {GenericModal} from '../../../rebrand2020/Hop/components/generic-modal';

// bar nav quote creation
Hop.defineModule('modal-quote-blocked-corpo-draft', (root, param) => {
    const clientFirstName = param.clientFirstName;
    const freelancerCompanyId = param.freelancerCompanyId;

    const popup = new GenericModal({
        title: Hop.message('business.proposal.draft.modal.freelance.not.compliant.title'),
        message: Hop.message('business.proposal.draft.modal.freelance.not.compliant.content', Hop.escapeHtml(clientFirstName)),
        confirmLabel: Hop.message('business.proposal.draft.modal.freelance.not.compliant.button'),
        notabene: Hop.message('business.proposal.draft.modal.freelance.not.compliant.notabene'),
    });

    function showPopup() {
        popup.show(() => {
            window.location.href = `/freelancer/company/${freelancerCompanyId}/my-legal-documents`;
        });
    }

    Hop.events.on('draft-quote:show-compliance-popup', showPopup);

    if (param.showPopupAfterPageLoaded) {
        showPopup();
    }

    return function destroy() {
        Hop.events.off('draft-quote:show-compliance-popup', showPopup);
    };
});
